import { useMemo } from "react";

import type { CreatableComboBoxProps } from "@braintrust/braintrust-ui-components";
import { CreatableComboBox } from "@braintrust/braintrust-ui-components";
import { useGetSchoolsQuery } from "@js/apps/freelancer/api";

import { useSearchPhrase } from "../../hooks/search-phrase";

export type SchoolsCreatableComboboxProps = Omit<
  CreatableComboBoxProps<true>,
  "options"
>;

export const SchoolsCreatableCombobox = (
  props: SchoolsCreatableComboboxProps,
) => {
  const { onInputChange, searchPhrase } = useSearchPhrase();

  const { data } = useGetSchoolsQuery({
    search: searchPhrase,
    limit: 100,
  });

  const options = useMemo(() => {
    return (data || []).map((opt) => ({
      value: opt.name,
      label: opt.name,
    }));
  }, [data]);

  return (
    <CreatableComboBox
      onInputChange={onInputChange}
      options={options}
      disableClearable
      {...props}
    />
  );
};
